import React, { Component } from 'react';
import { compose } from 'redux';
import withRouter from 'app/withRouter';
import './LiffScreen.scss';
import axios from 'axios';

export class LiffScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFiles: [], // เปลี่ยนจาก selectedFile เป็น array
            collectionsData: [],
            selectedCollection: null,
            loading: true,
            isUploading: false,
        };
    }

    async componentDidMount() {
        try {
            const response = await axios.get('/api/2/collections/list');
            if (response.status === 200) {
                this.setState({ collectionsData: response.data.results, loading: false });
            }
        } catch (error) {
            this.setState({ loading: false });
        }

        document.title = 'งานที่ได้รับมอบหมาย';
        const navbar = document.querySelector('.Navbar');
        if (navbar) {
            navbar.style.display = 'none';
        }
    }

    handleFileChange = (event) => {
        this.setState({ selectedFiles: Array.from(event.target.files) }); // แปลงเป็น array
    };

    handleCollectionSelect = (collectionId) => {
        this.setState({ selectedCollection: collectionId });
    };

    handleFileUpload = async () => {
        const { selectedFiles, selectedCollection } = this.state;
    
        if (selectedFiles.length === 0) {
            alert('กรุณาเลือกไฟล์อัปโหลด');
            return;
        }
    
        if (!selectedCollection) {
            alert('กรุณาเลือกเคส');
            return;
        }
    
        this.setState({ isUploading: true });
    
        try {
            for (const file of selectedFiles) {
                const formData = new FormData();
                formData.append('file', file);
                const metadata = {
                    file_name: file.name,
                    mime_type: file.type,
                };
                formData.append('meta', JSON.stringify(metadata));
    
                const response = await axios.post(`/api/2/documents/${selectedCollection}/ingest`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                if (response.status !== 201) {
                    alert(`บันทึกไฟล์ ${file.name} ไม่สำเร็จ`);
                }
            }
    
            alert('บันทึกไฟล์ทั้งหมดสำเร็จ');
    
            // รีเซ็ตค่าเพื่อให้พร้อมสำหรับการเลือกเคสใหม่
            this.setState({
                isUploading: false,
                selectedFiles: [],
                selectedCollection: null, // รีเซ็ตเคสที่เลือก
            });
        } catch (error) {
            alert('เกิดข้อผิดพลาดในการอัปโหลดไฟล์');
        } finally {
            this.setState({ isUploading: false });
        }
    };

    render() {
        const { collectionsData, loading, isUploading, selectedCollection, selectedFiles } = this.state;

        return (
            <div className="liff-screen">
                <h1 className="header">งานที่ได้รับมอบหมาย</h1>

                <div className="collections-section">
                    <label className="label">เลือกเคส:</label>
                    {loading ? (
                        <p className="loading-text">Loading...</p>
                    ) : (
                        <div className="collections-grid">
                            {collectionsData && collectionsData.length > 0 ? (
                                collectionsData.map((collection) => (
                                    <div
                                        key={collection.id}
                                        className={`collection-card ${selectedCollection === collection.id ? 'selected' : ''}`}
                                        onClick={() => this.handleCollectionSelect(collection.id)}
                                    >
                                        {collection.label}
                                    </div>
                                ))
                            ) : (
                                <p className="no-data">No collections available</p>
                            )}
                        </div>
                    )}
                </div>

                {/* แสดงส่วนอัปโหลดไฟล์เฉพาะเมื่อเลือกเคสแล้ว */}
                {selectedCollection && (
                    <div className="file-upload-section">
                        <label className="label">อัปโหลดไฟล์:</label>
                        <input
                            type="file"
                            className="file-input"
                            onChange={this.handleFileChange}
                            accept="*/*"
                            multiple // ทำให้เลือกหลายไฟล์ได้
                        />
                        <p className="selected-files">
                            {selectedFiles.length > 0
                                ? `เลือกไฟล์ ${selectedFiles.length} ไฟล์`
                                : 'ยังไม่ได้เลือกไฟล์'}
                        </p>
                        <button className="upload-button" onClick={this.handleFileUpload} disabled={isUploading}>
                            {isUploading ? 'กำลังบันทึกเคส' : 'บันทึกเคส'}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default compose(withRouter)(LiffScreen);
